/**
 * Bases por ambiente (Vue CLI mode → .env.pruebas | .env.preprod | .env.production).
 * Webpack reemplaza process.env.VUE_APP_* en build time.
 */
const trimSlash = (s) => String(s || '').replace(/\/+$/, '')

export const APP_ENV = process.env.VUE_APP_ENV || 'pruebas'

export const COTIZADOR_BASE = trimSlash(
  process.env.VUE_APP_COTIZADOR_BASE || 'http://pcotizador.socasesores.com:8080'
)

export const SISEC_BASE = trimSlash(
  process.env.VUE_APP_SISEC_BASE || 'https://papivalidacionriesgos.sisec.mx'
)

export const CATALOGOS_BASE = trimSlash(
  process.env.VUE_APP_CATALOGOS_BASE || 'https://papicatalogos.socasesores.com'
)

/** emailComparale (pruebas) | emailComparaleProd (preprod y prod) */
export const EMAIL_FOLDER =
  process.env.VUE_APP_EMAIL_FOLDER || 'emailComparale'

export const APIPRO_BASE = COTIZADOR_BASE + '/apipro/'

export function cotizadorUrl(path = '') {
  const p = String(path || '')
  if (!p) return COTIZADOR_BASE
  return COTIZADOR_BASE + (p.charAt(0) === '/' ? p : '/' + p)
}

export function sisecUrl(path = '') {
  const p = String(path || '')
  if (!p) return SISEC_BASE
  return SISEC_BASE + (p.charAt(0) === '/' ? p : '/' + p)
}

/** /emailComparale/... o /emailComparaleProd/... */
export function emailUrl(path = '') {
  const p = String(path || '').replace(/^\/+/, '')
  return COTIZADOR_BASE + '/' + EMAIL_FOLDER + (p ? '/' + p : '')
}

/** /admin/formatos/emailComparale[Prod]/... */
export function emailFormatosUrl(path = '') {
  const p = String(path || '').replace(/^\/+/, '')
  return (
    COTIZADOR_BASE +
    '/admin/formatos/' +
    EMAIL_FOLDER +
    (p ? '/' + p : '')
  )
}

export default {
  APP_ENV,
  COTIZADOR_BASE,
  SISEC_BASE,
  CATALOGOS_BASE,
  EMAIL_FOLDER,
  APIPRO_BASE,
  cotizadorUrl,
  sisecUrl,
  emailUrl,
  emailFormatosUrl,
}
